
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Notify } from "quasar";
import generalService from "@/services/general.service";
import Buscador from "@/components/Common/Web/Buscador.vue";
import categoryService from "@/services/category.service";
import { getSearchableTramites } from "@/services/tramites-search.service";

interface dataCard {
  id: number | any;
  name?: string;
  title?: string;
  description?: string;
  tags?: Array<any>;
}

@Component({
  components: {
    Buscador
  }
})
export default class BusquedaTramitesCardComponent extends Vue {
  private popular: Array<any> = [];
  private search: String = "";
  private tramite: any = {};
  private tramitesBuscador: Array<dataCard> = [];
  private filteredTramitesBuscador: Array<any> = [];
  private searchTramite: String = "";

  private async mounted() {
    this.getPopular();
    await this.loadTramitesBuscador();
  }
  private async getPopular() {
    const response = await generalService.getPopularTramites();
    this.popular = response;
  }
  private goToTramites() {
    this.$router.push("/portal-servicios");
  }
  private goToPopular(tramite: any) {
    if (tramite.model === "Tramite") {
      this.$router.push(`/portal-servicios/${tramite.link}`);
    } else if (tramite.model === "Pagina") {
      this.$router.push(`/${tramite.link}`);
    } else if (tramite.model === "Galeria") {
      this.$router.push(`/galeria/${tramite.link}`);
    } else if (tramite.model === "Noticia") {
      this.$router.push(`/noticias/publicacion/${tramite.id}/${tramite.link}`);
    } else if (tramite.model === "LinkExterno") {
      this.toLink(tramite.link);
    } else if (tramite.model === "Link") {
      if (tramite.tipo === "1") {
        this.$router.push(`/${tramite.link}`);
      } else if (tramite.tipo === "0") {
        this.toLink(tramite.link);
      }
    }
  }

  private toLink(item: any) {
    if (item && item != "") {
      window.open(item, "_blank");
    } else {
      return;
    }
  }

  private buscar() {
    if (this.search && this.search.length > 3) {
      this.$store.commit("SET_MODAL_BUSCADOR", true);
    }
  }

  private async loadTramitesBuscador() {
    const response = await categoryService.getTramites();
    this.tramitesBuscador = getSearchableTramites(response).map((x: any) => {
      return {
        id: x.id,
        name: x.name,
        title: x.name.toUpperCase(),
        description: x.description,
        slug: x.slug,
        tags: x.tags || []
      };
    });
  }

  private inputTramites(value: any) {
    if (value && this.search && typeof this.search !== "string") {
      this.search = "";
    }
    this.searchTramite = value;
  }

  private filterFn(
    val: string,
    update: (fn: () => void) => void,
    abort: () => void
  ): void {
    update(() => {
      const needle = this.normalizeText(val);
      if (!needle) {
        this.filteredTramitesBuscador = [];
      } else {
        this.filteredTramitesBuscador = this.tramitesBuscador
          .filter((tramite: any) => this.matchesSearchTerm(tramite, needle))
          .map((tramite: any) => ({
            label: tramite.title,
            value: tramite.id,
            slug: tramite.slug
          }));
      }
    });
  }
  private normalizeText(text: string) {
    return text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }
  private matchesSearchTerm(tramite: any, normalizedNeedle: string) {
    const searchableText = [
      tramite?.name || tramite?.title || "",
      tramite?.description || "",
      ...(tramite?.tags || []).map((tag: any) => tag?.name || "")
    ].join(" ");

    return this.normalizeText(searchableText).includes(normalizedNeedle);
  }
  get highlightedOptions() {
    return this.filteredTramitesBuscador.map(opt => ({
      ...opt,
      highlightedLabel: this.highlightMatch(opt.label)
    }));
  }
  private highlightMatch(text: string) {
    if (!this.searchTramite) return text;

    const normalizeText = (str: any) =>
      str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

    const originalText = text;
    const normalizedText = normalizeText(text);
    const normalizedSearch = normalizeText(this.searchTramite);

    const index = normalizedText.indexOf(normalizedSearch);
    if (index === -1) return text; // No hay coincidencia

    const matchedPart = originalText.substring(
      index,
      index + this.searchTramite.length
    );

    return originalText.replace(matchedPart, `<b>${matchedPart}</b>`);
  }
  private buscarTramite() {
    if (this.searchTramite.length > 0)
      this.$router.push(`/busqueda-tramites/${this.searchTramite}`);
  }
  private goToTramiteRelacionado(nombre_web: string) {
    this.$router.push({
      path: `/portal-servicios/${nombre_web}`,
      query: { scrollTo: "title" }
    });
  }

  get visiblePopular() {
    return this.$q.screen.xs || this.$q.screen.sm
      ? this.popular.slice(0, 4)
      : this.popular;
  }
}
